import React from 'react'
import { Form, FormField } from '@foodsby/nutrient'
import us from 'us'
import { Submitting } from '../common/Submitting'

const SubmitBuildingForm = ({
  submitting,
  onSubmit,
  invalid,
  error,
  street,
  city,
  state,
  zip
}) => (
  <Form onSubmit={onSubmit}>
    <FormField
      type="hidden"
      name="oid"
      value={process.env.REACT_APP_SALESFORCE_OID}
    />
    <FormField type="hidden" name="debug" value="1" />
    <FormField type="hidden" name="debugEmail" value="buildings@foodsby.com" />
    <div className="row start-xs">
      <div className="col-xs-12">
        <FormField
          id="street"
          name="street"
          type="text"
          label="Address *"
          required
          value={street}
        />
      </div>
    </div>
    <div className="row start-xs">
      <div className="col-xs-12 col-md-4">
        <FormField
          id="city"
          name="city"
          type="text"
          label="City *"
          required
          value={city}
        />
      </div>
      <div className="col-xs-12 col-md-4">
        <FormField
          id="state"
          name="state_code"
          type="select"
          label="State *"
          required
          value={state}
        >
          <option value="">Please Choose</option>
          {Object.keys(us.states).map(state => {
            return (
              <option key={state} value={state}>
                {state}
              </option>
            )
          })}
        </FormField>
      </div>
      <div className="col-xs-12 col-md-4">
        <FormField
          id="zip"
          name="zip"
          type="text"
          label="Zip Code *"
          required
          value={zip}
        />
      </div>
    </div>
    <div className="row start-xs">
      <div className="col-xs-12 col-md-6">
        <FormField
          id="first_name"
          name="first_name"
          type="text"
          required
          label="First Name *"
        />
      </div>
      <div className="col-xs-12 col-md-6">
        <FormField
          id="last_name"
          name="last_name"
          type="text"
          required
          label="Last Name *"
        />
      </div>
    </div>
    <div className="row start-xs">
      <div className="col-xs-12 col-md-6">
        <FormField
          id="email"
          name="email"
          type="email"
          label="Email *"
          required
        />
      </div>
      <div className="col-xs-12 col-md-6">
        <FormField
          id="phone"
          name="phone"
          type="tel"
          mask="(999) 999-9999"
          label="Phone"
        />
      </div>
    </div>
    <div className="row start-xs">
      <div className="col-xs-12 col-md-6">
        <FormField
          id="company"
          name="company"
          type="text"
          label="Company *"
          required
        />
      </div>
      <div className="col-xs-12 col-md-6">
        <FormField
          id="00Nf4000008kZgl"
          name="Number_of_Employees__c"
          label="Number of Employees"
          type="select"
        >
          <option value="">Please Choose</option>
          <option value="&lt;100">&lt;100</option>
          <option value="100-250">100 - 250</option>
          <option value="250+">250 +</option>
        </FormField>
      </div>
    </div>
    <div className="row start-xs">
      <FormField
        id="description"
        name="description"
        type="textarea"
        label="Comments"
      />
    </div>
    <FormField type="hidden" name="country_code" value="US" />
    <FormField type="hidden" name="lead_source" value="Foodsby Website" />
    <FormField type="hidden" name="recordType" value="012f4000000YP7O" />
    {submitting ? (
      <Submitting />
    ) : (
      <button
        type="submit"
        id="submit"
        className={invalid ? 'disabled' : 'primary'}
      >
        Submit
      </button>
    )}
    {error && <div className="slide error">{error}</div>}
  </Form>
)

export default SubmitBuildingForm
